/**
 * Constructor.js
 * Кастомайзер щипцов на витрине Shopify.
 *
 * Скрипт в liquid подключается ДО jquery.min.js и image-picker.min.js,
 * поэтому нельзя обращаться к $ на верхнем уровне — будет
 * "Uncaught ReferenceError: $ is not defined".
 * Сначала ждём jQuery, DOM и image-picker, и только потом инициализируемся.
 */
(function bootstrapConstructor(attempt) {
  var MAX_ATTEMPTS = 200;

  if (typeof window.jQuery === 'undefined') {
    if (attempt >= MAX_ATTEMPTS) {
      console.error('Constructor: jQuery не загрузился. Подключите jquery.min.js до constructor.js.');
      return;
    }
    setTimeout(function () {
      bootstrapConstructor(attempt + 1);
    }, 25);
    return;
  }

  window.jQuery(function onDomReady($) {
    waitForImagePicker($, 0);
  });
})(0);

function waitForImagePicker($, attempt) {
  var MAX_ATTEMPTS = 200;
  var $selects = $('select.image-picker');
  var pickersReady = $('.image_picker_selector').length > 0;

  if (pickersReady) {
    initConstructor($);
    return;
  }

  if (typeof $.fn.imagepicker === 'function' && $selects.length && attempt > 8) {
    $selects.imagepicker({ show_label: true });
    initConstructor($);
    return;
  }

  if (attempt >= MAX_ATTEMPTS) {
    console.error('Constructor: image-picker не инициализировался.');
    return;
  }

  setTimeout(function () {
    waitForImagePicker($, attempt + 1);
  }, 25);
}

function initConstructor($) {
  /* =========================================================
   * Карта только разрешённых SKU.
   * Ключ = tip_id + handle_mat + handle_type + tip_type + tip_mat + tip_lever + handle_len
   * ========================================================= */
  var PRODUCT_MAP = {
    '11213141526172': { sku: '4-0395', id: '7459760406740', handle: '4-0395-cross_action_capsulorrhexis_forceps_with_scale' },
    '11213241526172': { sku: '4-0394', id: '7459760472276', handle: '4-0394-capsulorhexis-forceps-with-scale-cross-action' },
    '11213142526172': { sku: '4-0396', id: '7459760210132', handle: '4-0396-capsulorhexis-forceps-with-scale-cross-action' },
    '11213141516172': { sku: '4-0395T', id: '7459760308436', handle: '4-0395t-capsulorhexis-forceps-with-scale-cross-action' },
    '11213242526173': { sku: '4-0396/LR', id: '7598567129300', handle: '4-0396_lr_capsulorhexis_forceps_with_scale' },
    '11213241516172': { sku: '4-0395/MRT', id: '7598569455828', handle: '4-0395_mrt_capsulorhexis_forceps_with_scale' },
    '11213241526173': { sku: '4-0395/LR', id: '7598569717972', handle: '4-0395_lr_capsulorhexis_forceps_with_scale' },
    '11213241516171': { sku: '4-0395/SRT', id: '7598568931540', handle: '4-0395_srt_capsulorhexis_forceps_with_scale' },
    '11213241526271': { sku: '4-03952/SR', id: '7598567522516', handle: '4-03952_sr_capsulorhexis_forceps_with_scale' },
    '11223141526172': { sku: '4-0395S', id: '7459760373972', handle: '4-0395s_capsulorhexis_forceps_with_scale' },
    '11213141516171': { sku: '4-0395/SFT', id: '7598569193684', handle: '4-0395_sft_capsulorhexis_forceps_with_scale' },
    '11213141516273': { sku: '4-03952/LFT', id: '7598568702164', handle: '4-03952_lft_capsulorhexis_forceps_with_scale' },
    '11223141526171': { sku: '4-0395/SFS', id: '7598569291988', handle: '4-0395_sfs_capsulorhexis_forceps_with_scale' },
    '11213242526172': { sku: '4-0396/MR', id: '7598566768852', handle: '4-0396_mr_capsulorhexis_forceps_with_scale' },
    '11213242516172': { sku: '4-0396/MRT', id: '7598566605012', handle: '4-0396_mrt_capsulorhexis_forceps_with_scale' },
    '11223142526273': { sku: '4-03962/LFS', id: '7598565916884', handle: '4-03962_lfs_capsulorhexis_forceps_with_scale' }
  };

  /* В исходном switch у 4-0395/SFS был другой id — восстанавливаем. */
  PRODUCT_MAP['11223141526171'] = {
    sku: '4-0395/SFS',
    id: '6720128450626',
    handle: '4-0395_sfs_capsulorhexis_forceps_with_scale'
  };

  var IN_STOCK_SKUS = {
    '4-0395': true,
    '4-0395S': true,
    '4-0395T': true,
    '4-0394': true,
    '4-0396': true
  };

  var CONFIG_FIELDS = [
    'tip_id',
    'handle_mat',
    'handle_type',
    'tip_type',
    'tip_mat',
    'tip_lever',
    'handle_len'
  ];

  var TIP_IMAGES = {
    stss: {
      curved: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_curved.jpg?v=1643811601',
      straight: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_straight.jpg?v=1643811600',
      short: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_short.jpg?v=1643811601',
      long: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_long.jpg?v=1643811601'
    },
    ti: {
      curved: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_curved_ti.jpg?v=1647504660',
      straight: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_straight_ti.jpg?v=1647504658',
      short: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_short_ti.jpg?v=1647504658',
      long: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/tip_long_ti.jpg?v=1647504658'
    }
  };

  var HANDLE_IMAGES = {
    ti: {
      flat: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_flat_ti.jpg?v=1647504658',
      round: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_round_ti.jpg?v=1647504658',
      short: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_short_ti.jpg?v=1647504658',
      medium: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_medium_ti.jpg?v=1647504661',
      long: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_long_ti.jpg?v=1647504658'
    },
    stss: {
      flat: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_flat.jpg?v=1643811600',
      round: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_round.jpg?v=1643811600',
      short: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_short.jpg?v=1643811601',
      medium: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_medium_39fd2ecc-5ae8-42a4-b2fe-e4fda2210ec8.jpg?v=1643811601',
      long: 'https://cdn.shopify.com/s/files/1/0523/1155/6263/files/handle_long.jpg?v=1643811601'
    }
  };

  var state = {
    handle: '',
    productId: '',
    key: '',
    applying: false
  };

  var client = null;
  if (window.ShopifyBuy && typeof window.ShopifyBuy.buildClient === 'function') {
    client = window.ShopifyBuy.buildClient({
      domain: 'rumex-com.myshopify.com',
      storefrontAccessToken: 'f2862924a28b0b4f7cdcdf0932ff860a'
    });
  }

  function fieldValue(id) {
    var el = document.getElementById(id);
    if (!el || el.selectedIndex < 0) return '';
    return String(el.options[el.selectedIndex].value);
  }

  function readConfig() {
    var config = {};
    CONFIG_FIELDS.forEach(function (id) {
      config[id] = fieldValue(id);
    });
    return config;
  }

  function toKey(config) {
    return CONFIG_FIELDS.map(function (id) {
      return config[id];
    }).join('');
  }

  function parseKey(key) {
    var config = {};
    CONFIG_FIELDS.forEach(function (id, index) {
      config[id] = key.substr(index * 2, 2);
    });
    return config;
  }

  function usedValuesByField() {
    var used = {};
    CONFIG_FIELDS.forEach(function (id) {
      used[id] = {};
    });
    Object.keys(PRODUCT_MAP).forEach(function (key) {
      var config = parseKey(key);
      CONFIG_FIELDS.forEach(function (id) {
        used[id][config[id]] = true;
      });
    });
    return used;
  }

  function hideUnusedOptions() {
    var used = usedValuesByField();
    CONFIG_FIELDS.forEach(function (id) {
      var $select = $('#' + id);
      if (!$select.length) return;
      var $lis = $select.closest('.sel').find('.image_picker_selector li');
      $select.find('option').each(function (index) {
        var value = String(this.value);
        var allowed = !!used[id][value];
        this.disabled = !allowed;
        $lis.eq(index).toggle(!allowed ? false : true);
        $lis.eq(index).toggleClass('constructor-unavailable', !allowed);
      });
    });
  }

  function syncPickerWithSelect($select) {
    var value = String($select.val());
    var picker = $select.data('picker');
    if (picker && typeof picker.sync_picker_with_select === 'function') {
      picker.sync_picker_with_select();
    }
    var $lis = $select.closest('.sel').find('.image_picker_selector li');
    $select.find('option').each(function (index) {
      var selected = String(this.value) === value;
      $(this).prop('selected', selected);
      $lis.eq(index).find('.thumbnail').toggleClass('selected', selected);
    });
  }

  function applyConfigToForm(config) {
    state.applying = true;
    CONFIG_FIELDS.forEach(function (id) {
      var $select = $('#' + id);
      if (!$select.length) return;
      $select.val(config[id]);
      syncPickerWithSelect($select);
    });
    state.applying = false;
  }

  function findClosestProduct(fieldId, value, current) {
    var bestKey = null;
    var bestScore = Infinity;
    Object.keys(PRODUCT_MAP).forEach(function (key) {
      var config = parseKey(key);
      if (config[fieldId] !== String(value)) return;
      var score = 0;
      CONFIG_FIELDS.forEach(function (id) {
        if (id !== fieldId && config[id] !== current[id]) score += 1;
      });
      if (score < bestScore) {
        bestScore = score;
        bestKey = key;
      }
    });
    return bestKey;
  }

  function closeOtherDropdowns(currentBlock) {
    var $form = $(currentBlock).closest('form');
    $form.children('div').each(function () {
      if (this === currentBlock) return;
      var $arrow = $(this).find('.arrow-4');
      if ($arrow.hasClass('open')) {
        $arrow.removeClass('open');
        $(this).children('.image_picker_selector').slideUp(200);
      }
    });
  }

  function updatePreviewImages(config) {
    var tipSet = config.tip_mat === '51' ? TIP_IMAGES.ti : TIP_IMAGES.stss;
    var handleSet = config.handle_mat === '21' ? HANDLE_IMAGES.ti : HANDLE_IMAGES.stss;

    $('#tip_type').closest('.sel').find('li').eq(0).find('.image_picker_image').attr('src', tipSet.curved);
    $('#tip_type').closest('.sel').find('li').eq(1).find('.image_picker_image').attr('src', tipSet.straight);
    $('#tip_lever').closest('.sel').find('li').eq(0).find('.image_picker_image').attr('src', tipSet.short);
    $('#tip_lever').closest('.sel').find('li').eq(1).find('.image_picker_image').attr('src', tipSet.long);

    $('#handle_type').closest('.sel').find('li').eq(0).find('.image_picker_image').attr('src', handleSet.flat);
    $('#handle_type').closest('.sel').find('li').eq(1).find('.image_picker_image').attr('src', handleSet.round);
    $('#handle_len').closest('.sel').find('li').eq(0).find('.image_picker_image').attr('src', handleSet.short);
    $('#handle_len').closest('.sel').find('li').eq(1).find('.image_picker_image').attr('src', handleSet.medium);
    $('#handle_len').closest('.sel').find('li').eq(2).find('.image_picker_image').attr('src', handleSet.long);
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = value == null ? '' : value;
  }

  function slicePrice(amount) {
    if (amount == null) return '';
    return String(amount).slice(0, 3);
  }

  function applyProductToUi(productData) {
    if (!productData || !productData.handle) return;
    state.handle = productData.handle;
    state.productId = productData.id;
    setText('sku', productData.sku);
    setText('sku-mobile', productData.sku);

    if (!client || typeof client.product === 'undefined') return;

    client.product.fetchByHandle(productData.handle).then(function (product) {
      if (!product || !product.variants || !product.variants[0]) return;
      var variant = product.variants[0];
      var price = '$' + slicePrice(variant.price && variant.price.amount);
      setText('stock', price);
      setText('stock-mobile', price);
      $('.des').html(product.descriptionHtml || '');
      setText('ttl', product.title || '');
      setText('ttl-mobile', product.title || '');

      var img = document.getElementById('imgforc');
      if (img && product.images && product.images[0]) {
        img.src = product.images[0].src;
      }

      var compareAmount = variant.compareAtPrice && variant.compareAtPrice.amount;
      if (compareAmount && Number(compareAmount) > 0) {
        var oldPrice = '$' + slicePrice(compareAmount);
        setText('oldprice', oldPrice);
        setText('oldprice-mobile', oldPrice);
      } else {
        setText('oldprice', '');
        setText('oldprice-mobile', '');
      }

      var variantId = String(variant.id).substring(29);
      var productGid = String(product.id).substring(22);
      ['bis', 'bis-mobile'].forEach(function (id) {
        var btn = document.getElementById(id);
        if (!btn) return;
        if (product.onlineStoreUrl) btn.setAttribute('data-url', product.onlineStoreUrl);
        btn.setAttribute('data-variant-id', variantId);
        btn.setAttribute('data-product-id', productGid);
      });

      var sku = variant.sku || productData.sku;
      if (IN_STOCK_SKUS[sku]) {
        $('.disclaimer').css('display', 'none');
        $('#btn, #btn-mobile').attr('value', 'Buy now');
        $('#btn2, #btn2-mobile').css('display', 'none');
      } else {
        $('.disclaimer').css('display', 'initial');
        $('#btn, #btn-mobile').attr('value', 'Make to order');
        $('#btn2, #btn2-mobile').css('display', 'inline-block');
      }

      if (product.availableForSale) {
        $('#btn, #btn-mobile').css('display', 'inline-block');
        $('#soldout, #soldout-mobile, #bis, #bis-mobile').css('display', 'none');
      } else {
        $('#btn, #btn-mobile').css('display', 'none');
        $('#soldout, #soldout-mobile, #bis, #bis-mobile').css('display', 'inline-block');
      }
    }).catch(function (error) {
      console.error('Constructor: не удалось загрузить товар', productData.handle, error);
    });
  }

  function applyValidKey(key) {
    var productData = PRODUCT_MAP[key];
    if (!productData) return false;
    state.key = key;
    applyConfigToForm(parseKey(key));
    updatePreviewImages(parseKey(key));
    applyProductToUi(productData);
    return true;
  }

  function resolveSelection(fieldId, value) {
    var current = readConfig();
    current[fieldId] = String(value);
    var directKey = toKey(current);
    if (PRODUCT_MAP[directKey]) {
      applyValidKey(directKey);
      return;
    }
    var closestKey = findClosestProduct(fieldId, value, current);
    if (closestKey) {
      applyValidKey(closestKey);
      return;
    }
    if (state.key) applyValidKey(state.key);
  }

  /* Accordion: открыли один dropdown — закрыли остальные в той же форме. */
  $('.form1 > div, .form2 > div').on('click', 'span.name', function () {
    closeOtherDropdowns($(this).closest('div')[0]);
  });

  /* Клик по превью опции: оставляем только комбинации из PRODUCT_MAP. */
  $(document).on('click', '.image_picker_selector .thumbnail', function () {
    if (state.applying) return;
    var $select = $(this).closest('.sel').find('select');
    var fieldId = $select.attr('id');
    if (CONFIG_FIELDS.indexOf(fieldId) === -1) return;
    var index = $(this).closest('li').index();
    var option = $select.find('option').get(index);
    if (!option || option.disabled) return;
    var value = String(option.value);
    setTimeout(function () {
      resolveSelection(fieldId, value);
    }, 0);
  });

  $('#btn, #btn-mobile').off('click.constructor').on('click.constructor', function () {
    if (!client || !state.handle) return;
    client.product.fetchByHandle(state.handle).then(function (product) {
      if (!product || !product.variants || !product.variants[0]) return;
      var variantId = String(product.variants[0].id).substring(29);
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1&utm_source=customizer&utm_medium=referral&utm_campaign=add_to_cart';
    });
  });

  $('#product-info').off('click.constructor').on('click.constructor', function () {
    if (!state.handle) return;
    window.open('/products/' + state.handle + '?utm_source=customizer&utm_medium=referral&utm_campaign=learn_more', '_blank');
  });

  $('#reset, #reset2').off('click.constructor').on('click.constructor', function () {
    window.location.href = '/pages/customizer?utm_source=customizer&utm_medium=referral&utm_campaign=default';
  });

  $('#btn2, #btn2-mobile').off('click.constructor').on('click.constructor', function () {
    window.open('/collections/regular-cross-action-capsulorhexis-forceps?utm_source=customizer&utm_medium=referral&utm_campaign=go_to_regular_items', '_blank');
  });

  hideUnusedOptions();

  var initialKey = toKey(readConfig());
  if (!PRODUCT_MAP[initialKey]) {
    initialKey = Object.keys(PRODUCT_MAP)[0];
  }
  applyValidKey(initialKey);
}